import React from 'react';
import Spinner from '../Spinner/Spinner';

const DataLoading = () => <Spinner />;

export default DataLoading;
